export default function searchReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'POST_REPLACE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'POST_REPLACE_ERROR':
            return {...state, ...{error: action.error}};

        case 'POST_REPLACE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}